module.exports = __webpack_public_path__ + "media/images/gifts/sensations/sug_sensorial_4-fadd90d4b5672651bc0bd0279d7728a1.jpg";